module.exports = __webpack_public_path__ + "static/media/mountainl.84b3be19.jpg";